import { render, staticRenderFns } from "./DoctorSelect.vue?vue&type=template&id=09604d5d&scoped=true"
import script from "./DoctorSelect.vue?vue&type=script&lang=js"
export * from "./DoctorSelect.vue?vue&type=script&lang=js"
import style0 from "./DoctorSelect.vue?vue&type=style&index=0&id=09604d5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09604d5d",
  null
  
)

export default component.exports